import { render, staticRenderFns } from "./TheRecipientsTable.vue?vue&type=template&id=f7454930&scoped=true"
import script from "./TheRecipientsTable.vue?vue&type=script&lang=js"
export * from "./TheRecipientsTable.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsTable.vue?vue&type=style&index=0&id=f7454930&prod&lang=scss"
import style1 from "./TheRecipientsTable.vue?vue&type=style&index=1&id=f7454930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7454930",
  null
  
)

export default component.exports